import { Type } from 'typebox';
import { ConfigurableSubscriptions, SubscriptionChannels, SubscriptionTopicId, SubscriptionTopics, Subscriptions } from '@tadpoles/common';
export const SubscriptionsGetPayload = Type.Object({
    configurableSubscriptions: ConfigurableSubscriptions,
    subscriptions: Subscriptions
});
const SubscriptionUpdateTopicId = Type.Exclude(SubscriptionTopicId, Type.Literal(SubscriptionTopics.unknown));
export const SubscriptionUpdateTopic = Type.Object({
    topic: SubscriptionUpdateTopicId,
    channels: Type.Array(Type.Literal(SubscriptionChannels.push), {
        minItems: 1,
        maxItems: 1,
        uniqueItems: true
    })
});
export const SubscriptionsUpdateSet = Type.Object({
    channels: Type.Array(Type.Literal(SubscriptionChannels.email)),
    topics: Type.Array(SubscriptionUpdateTopic)
});
export const SubscriptionsUpdateRequest = Type.Union([
    Type.Object({
        add: SubscriptionsUpdateSet,
        remove: Type.Optional(SubscriptionsUpdateSet)
    }),
    Type.Object({
        add: Type.Optional(SubscriptionsUpdateSet),
        remove: SubscriptionsUpdateSet
    })
]);
export const SubscriptionsUpdatePayload = Type.Object({
    subscriptions: Subscriptions
});
export class HttpSubscriptionsResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async get(options) {
        return await this.#httpClient.get({
            path: '/subscriptions/parent',
            payloadSchema: SubscriptionsGetPayload,
            signal: options?.signal
        });
    }
    async update(request, options) {
        return await this.#httpClient.post({
            body: request,
            bodySchema: SubscriptionsUpdateRequest,
            path: '/subscriptions/parent',
            payloadSchema: SubscriptionsUpdatePayload,
            signal: options?.signal
        });
    }
}
